export default "__VITE_ASSET__BUsp5y4N__"